import { render, staticRenderFns } from "./oldManFile.vue?vue&type=template&id=691495e6&scoped=true&"
import script from "./oldManFile.vue?vue&type=script&lang=js&"
export * from "./oldManFile.vue?vue&type=script&lang=js&"
import style0 from "./oldManFile.vue?vue&type=style&index=0&id=691495e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691495e6",
  null
  
)

export default component.exports